import { Input } from 'antd';
import { useCallback } from 'react';

const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

const formatters = {
  phone: (val) => {
    const digits = val.replace(/\D/g, '').slice(0, 11);
    if (digits.length === 0) return '';
    let result = '+7';
    if (digits.length > 1) result += ' ' + digits.slice(1, 4);
    if (digits.length > 4) result += ' ' + digits.slice(4, 7);
    if (digits.length > 7) result += ' ' + digits.slice(7, 9);
    if (digits.length > 9) result += ' ' + digits.slice(9, 11);
    return result;
  },
  innKpp: (val) => {
    const digits = val.replace(/\D/g, '').slice(0, 19);
    if (digits.length <= 10) return digits;
    return `${digits.slice(0, 10)}/${digits.slice(10, 19)}`;
  },
  orgn: (val) => val.replace(/\D/g, '').slice(0, 13),
  bik: (val) => val.replace(/\D/g, '').slice(0, 9),
  rschet: (val) => val.replace(/\D/g, '').slice(0, 20),
  kschet: (val) => val.replace(/\D/g, '').slice(0, 20),

  email: (val) => {
    let clean = val.replace(/[^a-zA-Z0-9@._+-]/g, '').slice(0, 100);

    // если есть несколько '@', оставляем только первую
    const firstAt = clean.indexOf('@');
    if (firstAt !== -1) {
      // убираем все остальные '@'
      clean = clean.slice(0, firstAt + 1) + clean.slice(firstAt + 1).replace(/@/g, '');
    }

    return clean;
  },

  card: (val) => val.replace(/[^a-zA-Z0-9]/g, '').slice(0, 13),
  number: (val) => val.replace(/\D/g, '').slice(0, 30),
};


const MaskedInput = ({
  value = '',
  onChange,
  maskType = 'phone',
  onInvalidEmail,
  ...rest
}) => {
  const format = formatters[maskType] || ((v) => v);

  const handleChange = useCallback(
    (e) => {
      const raw = e.target.value;
      const formatted = format(raw);

      if (maskType === 'email' && onInvalidEmail) {
        onInvalidEmail(!emailRegex.test(formatted));
      }

      onChange?.({
        ...e,
        target: {
          ...e.target,
          value: formatted.replace(/\s/g, ''),
        },
      });
    },
    [onChange, maskType, format, onInvalidEmail]
  );

  const displayValue = format(value || '');

  return (
    <Input
      value={displayValue}
      onChange={handleChange}
      {...rest}
    />
  );
};

export default MaskedInput;
